import 'jquery-ui-dist/jquery-ui';
import filters from '../components/filters';

export default class collectionPage {
   constructor(){
   }

   init(){
      this.loadOtherPages();

      window.filter = new filters();

      this.setSizes('#products .product-item');

      if(!isTouch) {
         $('.name img, .name-first, .name-last').draggable({
         });
         
         $('.product-item').draggable({
         });
         
         $('.ruler').draggable({
         });
      }

      $('button.view-wall').on('click', function(e){
         e.preventDefault();
         $('.change-view.curr').removeClass('curr');
         $(this).addClass('curr');
         $('body').removeClass('ruler-out single');
          $('html').removeClass('snapper');
       });

       $('button.view-grid').on('click', function(e){
          e.preventDefault();
          $('.change-view.curr').removeClass('curr');
          $(this).addClass('curr');
          $('body').addClass('ruler-out');
          $('body').removeClass('single');
          $('html').removeClass('snapper');
        });

       $('button.view-single').on('click', function(e){
          e.preventDefault();
          $('.change-view.curr').removeClass('curr');
          $(this).addClass('curr');
          $('body').addClass('ruler-out single');
          $('html').addClass('snapper');
        });

      $('.product-load--inner').on('click', function(e){
         if(e.target == this) {
            e.preventDefault();
            e.stopPropagation();
            console.log('close');
            // if(e.target == this) {
            $('.product-close').click();
            // }
         }
      });

      /*
      $('.product-item--link').on('click', function(e){
         e.preventDefault();
         // ajax load
         let href = $(this).attr('href');
         $('#product-load .product-load--inner').load(href+' .product', function(){
            $('html').addClass('product-open');
            $('#product-load').addClass('open');
            $('#product-load .product').addClass('in');
         });
      });
      */

      // bind close
      $('#product-load .product-close').on('click', function(e){
         e.preventDefault();
         $('#product-load').removeClass('open');
         $('html').removeClass('product-open');
         setTimeout(function(){
            $('#product-load .product-load--inner').html('');
         }, 500);
      });
   }

   shuffle() {
      var ul = document.querySelector('#products.product-list');
      for (var i = ul.children.length; i >= 0; i--) {
         ul.appendChild(ul.children[Math.random() * i | 0]);
      }
   }

   setSizes(selector){
      $(selector).find('img').each(function(){

         if(window.innerWidth >= 800) {
            $(this).css({
               width : (Math.min(80, this.dataset.width)) + 'vw',
               height : this.dataset.height + 'vw',
               minWidth : (Math.min(80, this.dataset.width)) + 'vw',
               minHeight : this.dataset.height + 'vw',
            });
         } else {
            $(this).css({
               width : '',
               height : '',
               minWidth : '',
               minHeight : '',
            });
         }
      }).on('load', function(){
         const tar = $(this).closest('.product-item');
         const self = this;
         setTimeout(() => {
            $(tar).addClass('loaded');
            $(self).attr('srcset', $(self).attr('data-srcset'));
         }, 100);
      }).each(function(){
         if(this.complete) $(this).trigger('load');
      });
      $(selector).each(function(){
         let margTop = Math.random()*10 + 2 + 'rem';
         if(window.innerWidth <= 800) {
            margTop = Math.random() * 4 + 'rem';
            $(this).css({
               'top' : margTop
            });
            margTop = 0;
         }
         $(this).css({
            marginBottom : Math.random()*3 - 1.5 + 'rem',
            marginTop : margTop,
            marginLeft : Math.random()*12 + 5 + '%',
            marginRight : Math.random()*12 + 5 + '%'
         });
      });
   }

   launch() {
      // remove duplicates by data-id
      var seen = {};
      $('#products .product-item').each(function() {
         var txt = this.dataset.id;
         if (seen[txt])
            $(this).remove();
         else
            seen[txt] = true;
      });

      window.filter.checkFilters();
      this.shuffle();
      setTimeout(() => {
         $('html').addClass('coll-ok');
      }, 10);

      setTimeout(() => {
         if(window.wishlist) {
            window.wishlist.binds();
         } else {
            setTimeout(() => {
               if(window.wishlist) {
                  window.wishlist.binds();
               }
            }, 1000);
         }
      }, 200);
   }

   loadOtherPages(){
      const t = this;
      // Get all pagination links
      const curFilter = $('.catcats [checked]').length>0 ? $('.catcats [checked]').get(0).dataset.filter : 'all-products';

      const paginationLinks = document.querySelectorAll('.pagination .paginate-link');
      var paginationLinksCompleted = 0;
      
      if (paginationLinks.length > 0) {
         // Iterate through each pagination link and load the content
         paginationLinks.forEach(function (link, index) {
            const url = link.getAttribute('href');
            
            // Fetch the content from each paginated URL via AJAX
            fetch(url)
            .then(response => response.text())
            .then(html => {
               // Parse the returned HTML string to a DOM object
               const parser = new DOMParser();
               const doc = parser.parseFromString(html, 'text/html');
               
               // Get the product items from the fetched page
               const newProducts = doc.querySelectorAll('.product-item');

               t.setSizes(newProducts);
               
               // Append each product item to the existing product list container
               const productList = document.querySelector('#products');
               newProducts.forEach(function (product) {
                  // if(product.dataset.category != curFilter && curFilter != 'all-products') {
                  //    $(product).hide();
                  // }
                  let id = product.dataset.id;
                  // console.log(id);
                  if(!document.querySelector(`#products .product-item[data-id="${id}"]`)) {
                     productList.appendChild(product);
                  }
               });

               console.log('Page ' + (index + 2) + ' with ' + newProducts + ' products loaded successfully.');
               paginationLinksCompleted++;
               if(paginationLinksCompleted == paginationLinks.length) {
                  t.launch();
               }
            })
            .catch(error => {
               console.error('Error fetching paginated page:', error);
               paginationLinksCompleted++;
               if(paginationLinksCompleted == paginationLinks.length) {
                  t.launch();
               }
            });
         });
      }
   }
}